import {IconProps} from './types'

export default function CloudyIcon({size = 16, ...props}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M11.6667 14H6C5.13458 13.9997 4.28626 13.7589 3.54985 13.3043C2.81344 12.8497 2.21795 12.1993 1.82992 11.4257C1.44188 10.6521 1.2766 9.78593 1.35253 8.92384C1.42846 8.06175 1.74262 7.23776 2.2599 6.54395C2.77718 5.85013 3.4772 5.31382 4.28174 4.99495C5.08627 4.67608 5.96363 4.58721 6.81577 4.73827C7.66791 4.88933 8.46125 5.27437 9.10716 5.85036C9.75306 6.42636 10.2261 7.17061 10.4733 7.99996H11.6667C12.0606 7.99996 12.4507 8.07756 12.8147 8.22832C13.1787 8.37909 13.5094 8.60007 13.788 8.87864C14.0666 9.15722 14.2875 9.48793 14.4383 9.85191C14.5891 10.2159 14.6667 10.606 14.6667 11C14.6667 11.3939 14.5891 11.784 14.4383 12.148C14.2875 12.512 14.0666 12.8427 13.788 13.1213C13.5094 13.3999 13.1787 13.6208 12.8147 13.7716C12.4507 13.9224 12.0606 14 11.6667 14Z"
        stroke="#6D6D6D"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.6667 6.66671C14.6667 6.13627 14.456 5.62757 14.0809 5.25249C13.7058 4.87742 13.1971 4.66671 12.6667 4.66671H11.1953C10.9692 3.87092 10.4806 3.17497 9.80904 2.69186C9.13745 2.20875 8.32227 1.96685 7.49588 2.00546C6.66948 2.04407 5.88041 2.36092 5.25679 2.90454C4.63318 3.44816 4.21165 4.18664 4.06067 5.00004"
        stroke="#0054C2"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
